module.exports = __webpack_public_path__ + "static/media/user-angela-koda.e1208d2b.png";